// @flow
import { OrderedMap } from "immutable"

import activeABtests from "./abTests"

export const activeABtestsFilters = {
  AB26: [{ desc: "must be us", filter: ({ lang }: { lang: string }) => lang === "us" }],
}

export const activeABtestsMap = OrderedMap(activeABtests)

export function userIdToABTests(
  abSlot: string,
  cleanId: string,
  filterOptions: { [string]: string } = {},
) {
  if (!cleanId) {
    return "_noId"
  }

  // AB test may have some filtering functions which should pass to enable ab test
  if (Array.isArray(activeABtestsFilters[abSlot])) {
    const filters = activeABtestsFilters[abSlot]
    if (filters.some(({ filter }) => !filter(filterOptions))) {
      return "_outOfSegment"
    }
  }

  try {
    // just to prevent wrong format of userId
    const slotNumber = parseInt(abSlot.replace("AB", ""))
    const threshold = activeABtests[abSlot][2]
    const i = parseInt(cleanId.substring(slotNumber, slotNumber + 1), 16) >= threshold ? 1 : 0
    return activeABtests[abSlot][i]
  } catch (e) {
    return "_error"
  }
}

// eslint-disable-next-line flowtype/no-weak-types
export function getSplitsterVersions(splitster: Object) {
  return Object.keys(splitster).reduce(
    (acc, test) => ({ ...acc, [test]: [test, splitster[test].value].join("_") }),
    {},
  )
}

export function getABVersions(
  userId: ?string,
  getCookies: string => string,
  getQuery: string => string,
  filterOptions: { [string]: string },
): { [string]: string } {
  const cleanId = (userId || "").split("-").join("") // gets rid of '-'
  const versions = {}
  Object.keys(activeABtests).forEach(slot => {
    versions[slot] = userIdToABTests(slot, cleanId, filterOptions)
    let forceABVersion

    const forceByCookie = getCookies(`force_ab_version_${slot}`)
    if (forceByCookie) {
      forceABVersion = forceByCookie
    }

    // param can rewrite cookie
    const forceByParams = getQuery(`force_ab_version_${slot}`)
    if (forceByParams) {
      forceABVersion = forceByParams
    }

    if (forceABVersion && activeABtests[slot].includes(forceABVersion)) {
      versions[slot] = forceABVersion
    }
  })
  return versions
}

export function getNextVersion(abSlot: string, actualVersion: string) {
  return activeABtests[abSlot].indexOf(actualVersion) === 0
    ? activeABtests[abSlot][1]
    : activeABtests[abSlot][0]
}
